export type HomeFaq = {
  question: string
  answer: string
  category: 'General' | 'Pricing' | 'Performance' | 'Integrations' | 'Migration' | 'Compliance'
}

export const homeFaqs: HomeFaq[] = [
  {
    question: 'What makes Idukki different?',
    answer:
      'Most UGC tools pick one lane: shoppable video, or reviews, or a social wall. Idukki runs the whole stack in one platform: photos, video, reviews, rights management, hashtag campaigns, lookbooks and flipbooks, even digital signage. It works across Shopify, WooCommerce, BigCommerce, Wix and any HTML site, and every feature is included on every plan, so you are not upgrading tiers to unlock the thing you actually came for.',
    category: 'General',
  },
  {
    question: 'How do you price?',
    answer:
      'Pricing is banded by monthly widget impressions. Free is free forever up to 5,000 impressions; paid plans are $45/mo Starter (up to 10,000), $75/mo Growth (up to 20,000) and $200/mo Professional (up to 50,000); Enterprise is custom above 50,000. Annual billing saves 20%, every feature is included on every plan, and there is a 14-day free trial on paid plans, no credit card required.',
    category: 'Pricing',
  },
  {
    question: 'Will the widget hurt my Core Web Vitals?',
    answer:
      'No. The widget is 37 KB, lazy-loads, and contributes 0.001 to CLS in our reference tests. Bazaarvoice-style SEO damage simply does not happen here. We publish lab data per release.',
    category: 'Performance',
  },
  {
    question: 'How fast can I migrate from my current tool?',
    answer:
      "Most customers migrate in a day. We import your existing UGC, posts, hashtags and product catalog automatically. Send us a Loom of your current setup and we'll send you back a side-by-side migration plan.",
    category: 'Migration',
  },
  {
    question: 'Do you support headless / non-Shopify stacks?',
    answer:
      'Yes. Native widgets for Shopify, WooCommerce, BigCommerce and Wix; plus a one-line embed for any HTML site or headless framework (Next.js, Remix, Astro, Hydrogen, etc.).',
    category: 'Integrations',
  },
  {
    question: 'Who owns the rights to imported UGC?',
    answer:
      'You do. Idukki provides a DM-based rights request flow, an approval queue and a full audit trail, the kind of compliance regulated industries need. We never publish content you have not approved.',
    category: 'Compliance',
  },
]
